import {Component, OnInit} from '@angular/core';
import {
    AppAlertService,
    AuthenticationService,
    FormsService,
    SettingsAccountService,
    SubtitlesService,
    UserService,
} from "../../core";
import {HttpClient} from "@angular/common/http";

@Component({
    selector: 'delete-account',
    templateUrl: './delete-account.component.html',
    styleUrls: ['./delete-account.component.scss']
})
export class DeleteAccountComponent implements OnInit {
    email: string = '';
    showLoader: boolean = false;
    showForm: boolean = false;

    constructor(
        private appAlert: AppAlertService,
        private authentication: AuthenticationService,
        private forms: FormsService,
        private http: HttpClient,
        private settingsAccount: SettingsAccountService,
        private subtitles: SubtitlesService,
        public user: UserService,
    ) {
    }

    ngOnInit() {
        this.email = this.user.user_id ? this.settingsAccount.accountInformation.accountEmail : '';
        if (this.subtitles.downloaded) {
            this.showForm = true;
        } else {
            this.subtitles.subtitlesPromise.subscribe(() => {
                this.showForm = true;
            });
        }
    }

    goBack(): void {
        window.history.back();
    }

    subtitle(id: number): string {
        return this.subtitles.setSubtitle(id);
    }

    deleteAccount() {
        const isEmailValid = this.forms.validateEmail(this.email);
        if (!isEmailValid) {
            this.appAlert.showAppAlert(this.subtitles.setSubtitle(1342),
                this.subtitles.setSubtitle(475), null, false, null);
            return;
        }

        this.showLoader = true;

        this.http.delete(`/api/v1/account/email/${this.email}/i18n/${this.subtitles.language}`)
            .subscribe({
                next: () => {
                    this.showLoader = false;
                    this.appAlert.showAppAlert(this.subtitles.setSubtitle(13578),
                        this.subtitles.setSubtitle(1129),
                        this.closeAlert.bind(this), false, null
                    );
                },
                error: () => {
                    this.showLoader = false;
                    this.appAlert.showAppAlert((this.subtitles.setSubtitle(1941)),
                        this.subtitles.setSubtitle(475),
                        this.closeAlert.bind(this), false, null
                    );
                }
            });
    }

    closeAlert() {
        if (this.user.user_id) {
            this.authentication.logout();
        } else {
            window.location.href = '/login';
        }
    }
}
